import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_ENDPOINTS } from '../config/api';
// Image will be referenced by path
import './Login.css';

function Login() {
    const [identityNumber, setIdentityNumber] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!identityNumber.trim()) {
            setError('الرجاء إدخال رقم الهوية');
            return;
        }

        setLoading(true);
        setError('');

        try {
            const response = await fetch(API_ENDPOINTS.CHECK_USER, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ identity_number: identityNumber }),
            });

            const data = await response.json();

            if (response.ok && data.exists) {
                try { sessionStorage.setItem('employee', JSON.stringify(data.user)); } catch (_e) { /* ignore */ }
                if (data.user && data.user.role === 'admin') {
                    navigate('/admin', { state: { employee: data.user } });
                } else {
                    navigate('/form', { state: { identityNumber, employee: data.user } });
                }
            } else {
                setError('لم يتم العثور على الموظف، الرجاء التأكد من رقم الهوية');
            }
        } catch {
            setError('خطأ في الاتصال بالخادم');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-container">
            <div className="login-box">
                <div className="logo">
                    <img src="/images/logo_elharamain.png" alt="logo" />                </div>
                <div className="header">
                    <h1>نظام <span>التأمين الصحي</span></h1>
                    <p>رئاسة الشؤون الدينية بالمسجد الحرام والمسجد النبوي</p>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="identityNumber">رقم الهوية الوطنية</label>
                        <div className="input-wrap">
                            <div className="input-icon" aria-hidden="true" />
                            <input
                                type="text"
                                id="identityNumber"
                                value={identityNumber}
                                onChange={(e) => setIdentityNumber(e.target.value)}
                                placeholder="أدخل رقم الهوية"
                                disabled={loading}
                                maxLength="20"
                                autoComplete="off"
                            />
                        </div>
                    </div>

                    {error && <div className="error-message">{error}</div>}

                    <button type="submit" className="submit-btn" disabled={loading}>
                        {loading
                            ? <><span className="btn-spinner" /> جاري التحقق...</>
                            : 'دخول'}
                    </button>
                </form>

                <div className="login-footer">
                    &copy; {new Date().getFullYear()} PRAGOVSA — جميع الحقوق محفوظة
                </div>
            </div>
        </div>
    );
}

export default Login;
